import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-white tech-grid-light py-16 sm:py-20" aria-labelledby="system-title" data-id="element-233" data-mp="3bhu1186hy022">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-234" data-mp="36iqutkes5nsi">
        <span className="inline-flex items-center gap-2 rounded-md bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-greenGlow" data-id="element-235" data-mp="31kpakw5mbifg">
          <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-236" data-mp="2wsfoxsbjd4iz" /> El sistema más completo de energías renovables para el
          aula de habla hispana
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-237" data-mp="2ntu8q3tje1ld">
          Mega Pack Energías Renovables Listo
        </h2>
        <p className="mt-3 font-semibold text-muted" data-id="element-238" data-mp="2dv4tkit0yv8t">
          {totalVolumes} tomos · {totalBonuses} bonos estratégicos · Todo listo para usar desde hoy.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-239" data-mp="13xws757dp6wp">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-line bg-mist p-4 text-sm font-semibold text-muted" data-id="element-240" data-mp="18rrdgd2mttxw">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-241" data-mp="1rmpudjelgazr" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-green/40 bg-greenSoft p-6 text-left text-lg font-bold leading-relaxed text-ink" data-id="element-242" data-mp="1hptjx854xesk">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-green" aria-hidden="true" data-id="element-243" data-mp="6bg0qglbtniv" />
          Es un sistema para que entres al aula con confianza y dictes clases que de verdad enseñen a generar, almacenar
          y gestionar energía renovable.
        </p>
      </div>
    </section>;
}